import HomeContainer from './home.container'

export default HomeContainer
